import { Dropdown } from '@cmsgov/ds-medicare-gov';
import { ComponentProps } from 'react';
import translate from '../../common/functions/translate';
import Local from '../classes/local';


type DSDropdownProps = ComponentProps<typeof Dropdown>
type SecretQuestionDropdownProps = Pick<DSDropdownProps, 'value' | 'onBlur' | 'onChange' | 'inputRef'> & {
    context: 'unlockAccount' | 'createAccount' | 'login' | null
}

export const SecretQuestionDropdown = (props: SecretQuestionDropdownProps) => {

    const {
        value,
        onBlur,
        onChange,
        inputRef,
        context
    } = props;

    function getErrorMessage() {
        if (context === 'createAccount' || context === 'login' || context === 'unlockAccount') {
            return translate('pick_secret_question');
        } else {
            return null;
        }
    }
    // The list of questions is shared between this application, Medicare
    // Beneficiary Portal, and SLS. The values of these questions are validated
    // against a hard-coded list of strings in SLS, so we will hard-code them
    // here, too, rather than translating them. (The odd spacing in the Spanish
    // questions is intentional in order to match the validation strings in SLS)

    const questionList = {
        'English': [
            { label: translate('select_question'), value: '' },
            { label: 'What is your favorite vacation spot?', value: 'What is your favorite vacation spot?' },
            { label: 'In what city did you first meet your spouse?', value: 'In what city did you first meet your spouse?' },
            { label: 'What country would you most like to visit?', value: 'What country would you most like to visit?' },
            { label: 'What is the title of your favorite book?', value: 'What is the title of your favorite book?' },
            { label: 'What is the name of the first street you lived on?', value: 'What is the name of the first street you lived on?' },
            { label: 'What was the name of your first pet?', value: 'What was the name of your first pet?' },
            { label: `What is your best friend's last name?`, value: `What is your best friend's last name?` },
        ],
        'Spanish': [
            { label: translate('select_question'), value: '' },
            { label: '¿Cuál es su lugar favorito para vacacionar?', value: '¿ Cuál es su lugar favorito para vacacionar?' },
            { label: '¿En qué cuidad conoció primero usted a su cónyuge?', value: '¿ En qué cuidad conoció primero usted a su cónyuge?' },
            { label: '¿Que país le gustaría visitar?', value: '¿ Que país le gustaría visitar?' },
            { label: '¿Cuál es el título de su libro favorito?', value: '¿Cuál es el título de su libro favorito?' },
            { label: '¿Cuál es el nombre de la primera calle en la que usted vivió?', value: '¿ Cuál es el nombre de la primera calle en la que usted vivió?' },
            { label: '¿Cuál era el nombre de su primer animal doméstico?', value: '¿ Cuál era el nombre de su primer animal doméstico?' },
            { label: '¿Cuál es el apellido de su mejor amigo(a)?', value: '¿ Cuál es el apellido de su mejor amigo(a)?' },
        ]
    };

    const language: 'English' | 'Spanish' = Local.getItem('language') || 'English';

    return (
        <Dropdown
            aria-invalid={Boolean(context)}
            errorMessage={getErrorMessage()}
            inputRef={inputRef}
            label={translate('secret_question')}
            name={'secretQuestion'}
            onBlur={onBlur}
            onChange={onChange}
            options={questionList[language]}
            value={value}
        />
    );
};
